const smoothScroll = (elem, offset = 0) => {
  if (elem) {
    const { top } = elem.getBoundingClientRect();
    window.scrollTo({
      top: top + window.scrollY - offset,
      behavior: 'smooth',
    });
  }
};

export default smoothScroll;
